<template>
    <div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">방제사전 신규 등록</h2>
        </section>
        <section class="view">
          <div class="table_list">
            <table class="write">
              <colgroup>
                <col width="200">
                <col width="*">
              </colgroup>
              <tbody>
                <tr>
                  <th><span class="emp">방제명</span></th>
                  <td>
                    <input type="text" class="form_control" v-model="regData.dictionaryNm" placeholder="입력해주세요.">
                  </td>
                </tr>
                <tr>
                  <th><span>한자명</span></th>
                  <td>
                    <input type="text" class="form_control" v-model="regData.chinessNm" placeholder="입력해주세요.">
                  </td>
                </tr>
                <tr>
                  <th><span class="emp">출전</span></th>
                  <td>
                    <input type="text" class="form_control" v-model="regData.dictionarySource" placeholder="입력해주세요.">
                  </td>
                </tr>                
                <tr>
                  <th><span class="emp">사용여부</span></th>
                  <td>
                    <div class="form_inline">
                      <div class="form_radio">
                        <input type="radio"  value="Y" checked v-model="regData.useYn">
                        <label for="radio1">Y</label>
                      </div>
                      <div class="form_radio">
                        <input type="radio"  value="N" v-model="regData.useYn">
                        <label for="radio2">N</label>
                      </div>
                    </div>                   
                  </td>
                </tr>        
                <tr>
                  <th><span>처방설명</span></th>
                  <td>
                    <input type="text" class="form_control" v-model="regData.dictionaryNote1" placeholder="입력해주세요.">
                  </td>
                </tr>                           
                <tr>
                  <th><span>참고사항</span></th>
                  <td>
                    <input type="text" class="form_control" v-model="regData.dictionaryNote2" placeholder="입력해주세요.">
                  </td>
                </tr>                           
                <tr>
                  <th>약재명</th>
                  <td>
                    <div class="table_list">
                      <div class="table_option">
                        <div class="form_select"></div>
                        <button class="btn btn_md btn_blue" v-b-modal.medicineSearch>추가</button>
                      </div>
                      <table class="list no_view">
                        <colgroup>
                          <col width="100">
                          <col width="100">
                          <col width="100">
                          <col width="100">
                          <col width="100">
                        </colgroup>
                        <thead>
                          <tr>
                            <th>약재명</th>
                            <th>이명</th>
                            <th>설명</th>
                            <th>용량</th>
                            <th>삭제</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-if="medicineList.length == 0">
                                <td colspan="5"><span>입력된 약재가 없습니다.</span></td>
                            </tr>
                            <tr v-for="(item, index) in medicineList" :key="index">
                                <td><span>{{ item.med_hrb_nm }}</span></td>
                                <td><span>{{ item.med_alias }}</span></td>
                                <td><span>{{ item.med_prfm }}</span></td>
                                <td>
                                <input type="text" class="form_control xl_limit" v-model="item.med_use_qnty">
                                <span>g</span>
                                </td>
                                <td><button class="icon icon_del" @click="fn_medList_delete(index)"></button></td>
                            </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>                
              </tbody>
            </table>
            <div class="bottom_box">
              <button class="btn btn_md btn_outline" @click="fn_move_page">목록</button>
              <div class="btn_box">
                <!-- <button class="btn btn_md btn_gray">취소</button> -->
                <button class="btn btn_md btn_darkblue" @click="fn_reg">저장</button>
              </div>
            </div>
          </div>
        </section>
      </div>
      <SearchModal 
        :title="'약재 검색'" 
        :searchName="'약재명'"
        :oneBtn="true"
        :btnLeft="'적용'" 
        :btnRight="'닫기'"
        @callback="fn_callback"
      />
    </div>
</template>

<script>
  import axios from 'axios'
  import SearchModal from "@/modal/admin/medicineSearch.vue"
  import commonUtil from "@/mixin/commonUtil";

  export default {
    name: 'DictionaryMngtReg',
    mixins: [commonUtil],
    components: {
      SearchModal
    },
    data() {
      return {
        selected: null,
        regData : {
                dictionaryCd : "",
                dictionaryNm : "",
                chinessNm : "",
                dictionarySource : '',
                dictionaryNote1 : '',
                dictionaryNote2 : '',
                useYn : 'Y',
                status : ''
        },
        medicineList : []
      }
    },
    mounted(){
        this.regData.status = this.$store.getters['dictionary/getStatus'];
        
        console.log("@@@@ this.regData.status : %o",this.regData.status);

        if(this.regData.status == 'M'){
            this.fn_search() 
        }
    },
    methods : {
      fn_move_page(){
			  this.$store.dispatch('dictionary/setStatus', '');
			  this.$router.push("/admin/dictionary/dictionaryMngt");
		  },
      fn_callback (medObject){
        medObject.use_qy = 0;
        this.medicineList.push(medObject);            
		  },
      fn_reg(){

            if(this.regData.dictionaryNm == null || this.regData.dictionaryNm == ''){
                alert("방제명을 입력해주세요");
                return;
            }

            if(this.regData.dictionarySource == null || this.regData.dictionarySource == ''){
                alert("출전을 입력해주세요");
                return;
            }

            console.log("@@@@ regData : %o",this.regData);

                let param = new Object();
                param.dictionaryInfo = this.regData;
                param.medicineList = this.medicineList;

                axios.post("/api/admin/dictionary/regDictionary", 
                    param
                ).then((res) => {
                console.log("@@@@ res : %o",res);

                alert("저장되었습니다");
                this.fn_move_page();
            })
            .catch((err) => console.log(err));

        
      },
      fn_search(){

        let param = new Object();
        param.dictionaryCd = this.$store.getters['dictionary/getDictionaryCd'];

        console.log("@@@@ param : %o",param);

        axios
            .post("/api/admin/dictionary/getDictionaryDetail", param)
            .then((res) => {
                console.log("@@@@ dtl res : %o",res);
                
                let dictinaryInfo = res.data.dictionaryInfo;
                this.medicineList = res.data.dictionaryHerbList;

                this.regData.dictionaryCd = dictinaryInfo.dictionary_cd;
                this.regData.dictionaryNm = dictinaryInfo.dictionary_nm;
                this.regData.chinessNm = dictinaryInfo.dictionary_chinese_nm;
                this.regData.dictionarySource = dictinaryInfo.dictionary_source;
                this.regData.dictionaryNote1 = dictinaryInfo.dictionary_note1;
                this.regData.dictionaryNote2 = dictinaryInfo.dictionary_note2;
                this.regData.useYn = dictinaryInfo.use_yn;
     
                
                console.log("@@@@ dtl this.regData : %o",this.regData);

            })
            .catch((err) => console.log(err));
            
      },
      fn_medList_delete(idx){
        this.medicineList.splice(idx, 1);
      }
    }
  }
</script>